import GlyphIcon from "./GlyphIcon.mjs";

/**
 * This icon is from M. Balestra, not from GlyphIcons
 * @type {GlyphIcon}
 * @see {GlyphIcon}
 */
const ShareIcon = class extends GlyphIcon {
	render() {
		return(
			<GlyphIcon
				{...this.props}
				d="M11.37,8.07l-1.22-1.22L16,1l5.85,5.85-1.22,1.22-3.75-3.75v16.23h-1.74V4.32l-3.75,3.75ZM24.72,10.07h-6.11v1.74h6.11c.52,0,.87.35.87.87v15.7c0,.52-.35.87-.87.87H7.27c-.52,0-.87-.35-.87-.87v-15.7c0-.52.35-.87.87-.87h6.11v-1.74h-6.11c-1.48,0-2.62,1.13-2.62,2.62v15.7c0,1.48,1.13,2.62,2.62,2.62h17.45c1.48,0,2.62-1.13,2.62-2.62v-15.7c0-1.48-1.13-2.62-2.62-2.62Z"
			/>
		);
	}
}

export default ShareIcon;